import { render, staticRenderFns } from "./DefinirSenha.vue?vue&type=template&id=4be29bde&scoped=true"
import script from "./DefinirSenha.vue?vue&type=script&lang=js"
export * from "./DefinirSenha.vue?vue&type=script&lang=js"
import style0 from "./DefinirSenha.vue?vue&type=style&index=0&id=4be29bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be29bde",
  null
  
)

export default component.exports